import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchFaqParams } from 'src/app/core/models/faq/search-faq-params';
import { UpdateFaqRequest } from 'src/app/core/models/faq/update-faq-request';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor(private http: HttpClient) { }

  searchFaq(params: SearchFaqParams): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/faq/search`;
    return  this.http.post(url, params);
  }

  getFaqBySeqNo(seqNo: number): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/faq/${seqNo}`;
    return  this.http.get(url);
  }

  updateFaq(request: UpdateFaqRequest): Observable<any> {
    const url = `${environment.customerserviceApiUrl}/faq/update`;
    return  this.http.post(url, request);
  }
}
